module.exports = __webpack_public_path__ + "img/img36.8ee66deb.svg";